import store from "../../store/index";
import FhsCookie from "../cookies";
import axios from "axios";
import { FhsAxios } from "./index";
export const FhsCancelTokenInstance = axios.CancelToken;
export let FhsCancelToken = FhsCancelTokenInstance.source();
// import { FhsCancelToken } from "./index";
export const FhsInterceptors = {
  onRequest: async config => {
    // Searching Token in cookie
    let token_data = await FhsCookie.getItem("token_data");
    // If TOKEN is null
    if (token_data) {
      // Set token to header;
      config.headers["Authorization"] = `Bearer ${
        JSON.parse(token_data).access_token
      }`;
    }
    config.cancelToken = FhsCancelToken.token;
    if (config.cancelToken.reason) {
      console.log(config.cancelToken.reason);
      FhsCancelToken = FhsCancelTokenInstance.source();
      config.cancelToken = FhsCancelToken.token;
      // console.log("TOKEN CANCELED");
    }
    return config;
  },
  onError: error => {
    return Promise.resolve(error);
  },
  onResponse: response => {
    // console.log("- - - - - - - - - - - - - - - --  ");
    let { code } = response.data;
    // let response_result = response;
    if (code === 401 && store.getters.isLoggedIn) {
      // console.log(response);
      store.commit(
        "Request_MODULE/_status_code/setStatusCode",
        "Another session started"
      );
      store.dispatch("userLogout");
    }
    return Promise.resolve(response);
  }
};
